/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OrganizationHierarchy } from './OrganizationHierarchy';
import {
    OrganizationHierarchyFromJSON,
    OrganizationHierarchyFromJSONTyped,
    OrganizationHierarchyToJSON,
} from './OrganizationHierarchy';

/**
 * 
 * @export
 * @interface GetMeOrgsResp
 */
export interface GetMeOrgsResp {
    /**
     * 
     * @type {Array<OrganizationHierarchy>}
     * @memberof GetMeOrgsResp
     */
    org_hierarchy: Array<OrganizationHierarchy>;
}

/**
 * Check if a given object implements the GetMeOrgsResp interface.
 */
export function instanceOfGetMeOrgsResp(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "org_hierarchy" in value;

    return isInstance;
}

export function GetMeOrgsRespFromJSON(json: any): GetMeOrgsResp {
    return GetMeOrgsRespFromJSONTyped(json, false);
}

export function GetMeOrgsRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeOrgsResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'org_hierarchy': ((json['org_hierarchy'] as Array<any>).map(OrganizationHierarchyFromJSON)),
    };
}

export function GetMeOrgsRespToJSON(value?: GetMeOrgsResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'org_hierarchy': ((value.org_hierarchy as Array<any>).map(OrganizationHierarchyToJSON)),
    };
}

